module.exports = __webpack_public_path__ + "img/google-sheet.fc01452d.png";